/**
 * AUTO-GENERATED FILE - DO NOT EDIT
 * Generated by mj codegen manifest
 * App: mj_explorer
 * Dependency tree: 1 packages contain @RegisterClass
 *
 * This file imports every @RegisterClass decorated class by name and places
 * them in an exported array, creating a static code path that prevents
 * tree-shaking from removing them.
 */

/* eslint-disable @typescript-eslint/no-unused-vars */

// mj_generatedentities (59 classes)
import {
    AssociationDemoAccreditingBodyEntity,
    AssociationDemoAdvocacyActionEntity,
    AssociationDemoBoardMemberEntity,
    AssociationDemoBoardPositionEntity,
    AssociationDemoCampaignEntity,
    AssociationDemoCampaignMemberEntity,
    AssociationDemoCertificateEntity,
    AssociationDemoCertificationEntity,
    AssociationDemoCertificationRenewalEntity,
    AssociationDemoCertificationRequirementEntity,
    AssociationDemoCertificationTypeEntity,
    AssociationDemoChapterEntity,
    AssociationDemoChapterMembershipEntity,
    AssociationDemoChapterOfficerEntity,
    AssociationDemoCommitteeEntity,
    AssociationDemoCommitteeMembershipEntity,
    AssociationDemoCompetitionEntity,
    AssociationDemoCompetitionEntryEntity,
    AssociationDemoCompetitionJudgeEntity,
    AssociationDemoContinuingEducationEntity,
    AssociationDemoCourseEntity,
    AssociationDemoEmailClickEntity,
    AssociationDemoEmailSendEntity,
    AssociationDemoEmailTemplateEntity,
    AssociationDemoEnrollmentEntity,
    AssociationDemoEventEntity,
    AssociationDemoEventRegistrationEntity,
    AssociationDemoEventSessionEntity,
    AssociationDemoForumCategoryEntity,
    AssociationDemoForumModerationEntity,
    AssociationDemoForumPostEntity,
    AssociationDemoForumThreadEntity,
    AssociationDemoGovernmentContactEntity,
    AssociationDemoInvoiceEntity,
    AssociationDemoInvoiceLineItemEntity,
    AssociationDemoLegislativeBodyEntity,
    AssociationDemoLegislativeIssueEntity,
    AssociationDemoMemberEntity,
    AssociationDemoMemberFollowEntity,
    AssociationDemoMembershipEntity,
    AssociationDemoMembershipTypeEntity,
    AssociationDemoOrganizationEntity,
    AssociationDemoPaymentEntity,
    AssociationDemoPolicyPositionEntity,
    AssociationDemoPostAttachmentEntity,
    AssociationDemoPostReactionEntity,
    AssociationDemoPostTagEntity,
    AssociationDemoProductAwardEntity,
    AssociationDemoProductCategoryEntity,
    AssociationDemoProductEntity,
    AssociationDemoRegulatoryCommentEntity,
    AssociationDemoResourceCategoryEntity,
    AssociationDemoResourceDownloadEntity,
    AssociationDemoResourceEntity,
    AssociationDemoResourceRatingEntity,
    AssociationDemoResourceTagEntity,
    AssociationDemoResourceVersionEntity,
    AssociationDemoSegmentEntity,
    AssociationDemoflyway_schema_historyEntity,
} from 'mj_generatedentities';

/**
 * Runtime references to every @RegisterClass decorated class.
 * This array creates a static code path the bundler cannot tree-shake.
 *
 * Split into fixed-size chunks so no single array literal grows a union large
 * enough to trip TS2590; the exported array is their concatenation.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CLASS_REGISTRATIONS_0: any[] = [
    AssociationDemoAccreditingBodyEntity,
    AssociationDemoAdvocacyActionEntity,
    AssociationDemoBoardMemberEntity,
    AssociationDemoBoardPositionEntity,
    AssociationDemoCampaignEntity,
    AssociationDemoCampaignMemberEntity,
    AssociationDemoCertificateEntity,
    AssociationDemoCertificationEntity,
    AssociationDemoCertificationRenewalEntity,
    AssociationDemoCertificationRequirementEntity,
    AssociationDemoCertificationTypeEntity,
    AssociationDemoChapterEntity,
    AssociationDemoChapterMembershipEntity,
    AssociationDemoChapterOfficerEntity,
    AssociationDemoCommitteeEntity,
    AssociationDemoCommitteeMembershipEntity,
    AssociationDemoCompetitionEntity,
    AssociationDemoCompetitionEntryEntity,
    AssociationDemoCompetitionJudgeEntity,
    AssociationDemoContinuingEducationEntity,
    AssociationDemoCourseEntity,
    AssociationDemoEmailClickEntity,
    AssociationDemoEmailSendEntity,
    AssociationDemoEmailTemplateEntity,
    AssociationDemoEnrollmentEntity,
    AssociationDemoEventEntity,
    AssociationDemoEventRegistrationEntity,
    AssociationDemoEventSessionEntity,
    AssociationDemoForumCategoryEntity,
    AssociationDemoForumModerationEntity,
    AssociationDemoForumPostEntity,
    AssociationDemoForumThreadEntity,
    AssociationDemoGovernmentContactEntity,
    AssociationDemoInvoiceEntity,
    AssociationDemoInvoiceLineItemEntity,
    AssociationDemoLegislativeBodyEntity,
    AssociationDemoLegislativeIssueEntity,
    AssociationDemoMemberEntity,
    AssociationDemoMemberFollowEntity,
    AssociationDemoMembershipEntity,
    AssociationDemoMembershipTypeEntity,
    AssociationDemoOrganizationEntity,
    AssociationDemoPaymentEntity,
    AssociationDemoPolicyPositionEntity,
    AssociationDemoPostAttachmentEntity,
    AssociationDemoPostReactionEntity,
    AssociationDemoPostTagEntity,
    AssociationDemoProductAwardEntity,
    AssociationDemoProductCategoryEntity,
    AssociationDemoProductEntity,
    AssociationDemoRegulatoryCommentEntity,
    AssociationDemoResourceCategoryEntity,
    AssociationDemoResourceDownloadEntity,
    AssociationDemoResourceEntity,
    AssociationDemoResourceRatingEntity,
    AssociationDemoResourceTagEntity,
    AssociationDemoResourceVersionEntity,
    AssociationDemoSegmentEntity,
    AssociationDemoflyway_schema_historyEntity,
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CLASS_REGISTRATIONS: any[] = [
    ...CLASS_REGISTRATIONS_0,
];

/** Marker constant indicating the manifest has been loaded. */
export const CLASS_REGISTRATIONS_MANIFEST_LOADED = true;

/** Total @RegisterClass decorated classes discovered in dependency tree */
export const CLASS_REGISTRATIONS_COUNT = 59;

/** Packages imported by this manifest */
export const CLASS_REGISTRATIONS_PACKAGES = [
    'mj_generatedentities',
] as const;

// ===== BEGIN Open App client bootstrap (managed by `mj app` / `mj codegen manifest`) =====
// '@mj-biz-apps/sonar-ng' disabled by `mj app disable`
// '@mj-biz-apps/sonar-entities' disabled by `mj app disable`

export const OPEN_APP_CLIENT_MODULES: unknown[] = [];
(globalThis as Record<string, unknown>)['__mjOpenAppClientModules'] = OPEN_APP_CLIENT_MODULES;
// ===== END Open App client bootstrap =====
